var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33334C6.162 1.33334 4.66667 2.82868 4.66667 4.66668C4.66667 6.50468 6.162 8.00001 8 8.00001C9.838 8.00001 11.3333 6.50468 11.3333 4.66668C11.3333 2.82868 9.838 1.33334 8 1.33334ZM8 6.66668C6.89733 6.66668 6 5.76934 6 4.66668C6 3.56401 6.89733 2.66668 8 2.66668C9.10267 2.66668 10 3.56401 10 4.66668C10 5.76934 9.10267 6.66668 8 6.66668ZM14 14V13.3333C14 10.7607 11.906 8.66668 9.33333 8.66668H6.66667C4.09333 8.66668 2 10.7607 2 13.3333V14H3.33333V13.3333C3.33333 11.4953 4.82867 10 6.66667 10H9.33333C11.1713 10 12.6667 11.4953 12.6667 13.3333V14H14Z",
    fill: "#6F9800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKid);
export default __webpack_public_path__ + "static/media/kid.7417c510.svg";
export { ForwardRef as ReactComponent };